import Loading from "../../../components/loading";
import React, {useEffect, useState} from "react";
import associateServices from "../../../services";
import RankIcon from "../../../components/rank-icon";
import {useTranslation} from "react-i18next";
import {useNavigate, useSearchParams} from "react-router-dom";
import NoData from "../../../components/no-data";
import moment from "moment";
import SvgIcon from "../../../components/svg-icon";

const WheelLatest = props => {
    const {t} = useTranslation()
    const {activeType} = props
    const [loading, setLoading] = useState(true)
    const [list, setList] = useState([])
    const navigate = useNavigate()

    // todo get tournament sort !
    useEffect(() => {
        associateServices.getWheelLatestSpins({})
            .then(res => {
                setList(res?.data)
                setLoading(false)
            })
    }, [activeType?.type_id])

    const [searchParams, setSearchParams] = useSearchParams()


    const handleWheelPrizeDetail = prize => {
        searchParams.set('modal', 'wheel-prize')
        searchParams.set('prize', prize?.id)
        setSearchParams(searchParams)
    }
    if (loading)
        return <Loading/>


    return (
        <div className="table-responsive">
            {

                loading ? <Loading/> :
                    list?.length <= 0 ?
                        <div className={'col-12 d-flex align-items-center justify-content-center'}><NoData/></div> :
                        <>
                            <h2 className="post__title d-flex align-items-center gap-2">
                                {t('wheel.last-winners', '')}
                            </h2>
                            <table className="xtable xtable--small xtable--wheel">
                                {/*<thead>*/}
                                {/*<tr>*/}
                                {/*    <th>#</th>*/}
                                {/*    <th>{t('general.username', '#')}</th>*/}
                                {/*    <th></th>*/}
                                {/*    /!*<th>{t('general.date', '#')}</th>*!/*/}
                                {/*    <th>{t('general.gift', '#')}</th>*/}
                                {/*</tr>*/}
                                {/*</thead>*/}
                                <tbody className={"wheel-prizes"}>

                                {

                                    list?.map((item, i) => (
                                        <tr
                                            className="cursor-pointer fade-in"
                                            onClick={e => handleWheelPrizeDetail(item)}
                                            key={i}>
                                            <td>
                                                <div className="xtable__text xtable__text--grey">
                                                    {i + 1}
                                                </div>
                                            </td>
                                            <td>
                                            <span className="chat__user wheel-text">
                                              <RankIcon icon={item?.customer?.ranki}/>
                                              <button className="chat__name small" type="button">
                                                {item?.customer?.is_public ? item?.customer?.username : item?.customer?.masked_username}
                                              </button>
                                            </span>
                                            </td>

                                            <td>
                                                <div className="wheel-prize-image">
                                                    <RankIcon icon={item?.prize?.image}/>
                                                </div>
                                            </td>

                                            <td>
                                                <div
                                                    className="xtable__text xtable__text--green text-sm-end wheel-text">
                                                    {item?.prize?.name?.toUpperCase()}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                }

                                </tbody>
                            </table>
                        </>
            }
        </div>
    )


}

export default WheelLatest
